import { IBienLaiPrintRequest } from "./../../state/action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import {
  IBienLaiHuyRequest,
  IBienLaiHuyTheoLopRequest,
} from "../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiSelectByLopRequest } from "../../model/request/bien-lai/IBienLaiSelectByLopRequest";
import { IBienLaiSelectBySinhVienRequest } from "../../model/request/bien-lai/IBienLaiSelectBySinhVienRequest";
import { IBienLaiThuTheoLopCreateRequest } from "../../model/request/bien-lai/IBienLaiThuTheoLopCreateRequest";
import { apiClient } from "../apiClient";
import { IBienLaiThuCreateRequest } from "./../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IBienLaiThuUpdateRequest } from "./../../model/request/bien-lai/IBienLaiThuUpdateRequest";
import { IBienLaiSelectByThiSinhRequest } from "../../model/request/bien-lai/IBienLaiSelectByThiSinhRequest";
import { IBienLaiChangeChoPhepXuatHDRequest } from "../../model/request/bien-lai/IBienLaiChangeChoPhepXuatHDRequest";
import { IBienLaiSaveImportRequest } from "../../model/request/bien-lai/IBienLaiSaveImportRequest";
import { IBienLaiThuTheoLopRequest } from "../../model/request/bien-lai/IBienLaiThuTheoLopRequest";
export const BIEN_LAI_ENDPOINT = "bien-lai-thu";

export const bienLaiThuApi = {
  Create: (request: IBienLaiThuCreateRequest) =>
    apiClient.post(BIEN_LAI_ENDPOINT, request),
  // Sửa biên lai tại chỗ (giữ số phiếu) — backend PUT api/bien-lai-thu
  Update: (request: IBienLaiThuUpdateRequest) =>
    apiClient.put(BIEN_LAI_ENDPOINT, request),
  // Lịch sử sửa biên lai (các bản cũ)
  SelectLichSuSua: (id_bien_lai: number) =>
    apiClient.get(`${BIEN_LAI_ENDPOINT}/${id_bien_lai}/lich-su-sua`),
  CreateByLop: (request: IBienLaiThuTheoLopCreateRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/create-by-lop`, request),
  SelectBySinhVien: (request: IBienLaiSelectBySinhVienRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-hoc/${request.nam_hoc || "tat-ca"}/hoc-ky/${request.hoc_ky}/sinh-vien/${request.id_sv}`,
    ),
  SelectByLop: (request: IBienLaiSelectByLopRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-hoc/${request.nam_hoc || "tat-ca"}/hoc-ky/${request.hoc_ky}/lop/${request.id_lop}`,
    ),
  HuyByLop: (request: IBienLaiHuyTheoLopRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/huy-by-lop`, request),
  SelectByIDBienLai: (id_bien_lai: number) =>
    apiClient.get(`bien-lai-thu/${id_bien_lai}`),
  SelectBySoPhieuGroup: (request: IBienLaiThuTheoLopRequest) =>
    apiClient.get(
      `bien-lai-thu/hoc_ky/${request.hoc_ky}/nam_hoc/${request.nam_hoc}/so_phieu_group/${request.so_phieu_group}`,
    ),
  PrintBienLai: (request: IBienLaiPrintRequest) =>
    apiClient.post(`bien-lai-thu/print`, request),
  SelectPaging: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/select-data-paging`, request),
  Huy: (request: IBienLaiHuyRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/huy`, request),

  PreviewThuHoiSoDu: (id_bien_lai: number) =>
    apiClient.get(`${BIEN_LAI_ENDPOINT}/${id_bien_lai}/thu-hoi-so-du/preview`),
  // Phiếu CHI (chưa hủy) đã chi từ biên lai nguồn này — hiện khi hủy phiếu thu bị chặn.
  GetChiByNguon: (id_bien_lai: number) =>
    apiClient.get(`${BIEN_LAI_ENDPOINT}/${id_bien_lai}/chi-by-nguon`),
  // Phiếu chi gộp nhiều nguồn: preview thu hồi GỘP các biên lai nguồn (ví số dư chung).
  // add_back > 0: đang SỬA phiếu chi này → preview cộng lại phần chi của nó (trạng thái sau khi đảo).
  PreviewThuHoiSoDuMulti: (ids: number[], add_back = 0) =>
    apiClient.post(
      `${BIEN_LAI_ENDPOINT}/thu-hoi-so-du/preview-multi${
        add_back > 0 ? `?add_back=${add_back}` : ""
      }`,
      ids,
    ),

  ChangeChoPhepXuatHoaDon: (request: IBienLaiChangeChoPhepXuatHDRequest) =>
    apiClient.post(
      `${BIEN_LAI_ENDPOINT}/change-cho-phep-xuat-hoa-don`,
      request,
    ),

  Preview: (request: IBienLaiThuCreateRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/preview`, request),

  SelectByThiSinh: (request: IBienLaiSelectByThiSinhRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-tuyen-sinh/${request.nam_tuyen_sinh}/thi-sinh/${request.id_thi_sinh}`,
    ),

  ExportExcel: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/export-excel`, request),
  /** Xem trước bản in bảng kê (mẫu 01): HTML dựng từ chính file Excel, vài chục dòng đầu. */
  XemTruocBangKe: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/xem-truoc-bang-ke`, request),
  Print: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/print-report`, request),
  SyncKeToanFast: (request: number[]) =>
    apiClient.post(`ket-noi-du-lieu/fast/receipt`, request),

  Import: (request: FormData) =>
    apiClient.upload(`${BIEN_LAI_ENDPOINT}/import`, request),
  SaveImport: (request: IBienLaiSaveImportRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/save-import`, request),
  /** Đồng bộ công nợ theo ĐÚNG khoảng ngày đang lọc trên lưới.
   *  tu_ngay/den_ngay: chuỗi GIỜ ĐỊA PHƯƠNG (formatDateTimeISO), KHÔNG dùng Date thô —
   *  axios sẽ toISOString() và 00:00 giờ VN thành 17:00Z hôm trước, lùi hẳn 1 ngày.
   *  Bỏ trống cả hai = giữ hành vi cũ: từ đầu ngày hôm nay đến hiện tại.
   *  loc_theo_gio khớp ô "Bỏ qua giờ" của bộ lọc để phạm vi đồng bộ trùng khít phần đang xem. */
  DongBoCongNo: (
    process_id: string,
    tu_ngay?: string,
    den_ngay?: string,
    loc_theo_gio?: boolean,
  ) =>
    apiClient.post(
      `${BIEN_LAI_ENDPOINT}/dong-bo-cong-no-trong-ngay?process_id=${process_id}` +
        (tu_ngay ? `&tu_ngay=${encodeURIComponent(tu_ngay)}` : "") +
        (den_ngay ? `&den_ngay=${encodeURIComponent(den_ngay)}` : "") +
        `&loc_theo_gio=${loc_theo_gio ? "true" : "false"}`,
    ),
};
